module.exports = __webpack_public_path__ + "vue-icon.svg?c27f74e48e2b0b63cbbb52088c6cc1e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/vue-icon.svg
// module id = 45
// module chunks = 0